<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Roles') : $t('New Role')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-select
              v-model="formValues.permissions"
              multiple
              :items="permissions"
              label="Berechtigungen"
              item-text="name"
            ></v-select>
            <div v-if="$route.params.id">
              <h4 class="font-weight-light mb-2 mt-8">
                {{ $t("Assigned users") }}
              </h4>
              <v-data-table
                :headers="headers"
                :items="formValues.assigned_users"
                :loading="loading"
                :multi-sort="true"
                class="elevation-1"
                :footer-props="{
                  'items-per-page-options': [10, 15, 50, -1]
                }"
              >
                <template v-slot:item.action="{ item }">
                  <v-icon small class="mr-2" @click="editUser(item)">
                    mdi-pencil
                  </v-icon>
                </template></v-data-table
              >
            </div>

            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'roles.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveRole">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveRole, fetchRole, fetchPermissions } from "../shared/services";
export default {
  name: "app-role-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    this.getPermissions();
    if (this.$route.params.id) {
      this.loading = true;
      fetchRole(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        name: this.formValues.name,
        permissions: this.formValues.permissions
      };
    }
  },
  methods: {
    async getPermissions() {
      this.loading = true;
      let response = await fetchPermissions(this.options);
      this.permissions = response.data;
      this.loading = false;
    },
    async saveRole() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveRole(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        if (resp.data && resp.data.password) {
          await this.$root.$confirm(this.$t("Role created"));
        }

        this.$root.$notification(resp.message);
        this.$router.push({ name: "roles.index" });
      }
    },
    editUser(item) {
      let url = item.id;
      this.$router.push({ name: "user.edit", params: { id: url } });
    }
  }
};
</script>

<style lang="scss" scoped></style>
